import React from 'react'
import { Field } from 'formik'

export default function CheckboxInput({className, name,...props }) {

    return (
        <Field className={className} id={name} name={name} type='checkbox' {...props} />
    )
}
